import React, { useState } from 'react';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AdminReviews.css';
import { compose } from 'redux';

import AdminReviewsManagement from '../../../../components/siteadmin/WhyHostPageSettings/AdminReviewsManagement/AdminReviewsManagement';
import Loader from '../../../../components/Loader/Loader';

import reviewsManagement from './reviewsManagement.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

function AdminReviews(props) {
    const { reviewsManagement, reviewsManagement: { getWhyHostAllReviews, loading } } = props;
    const [adminReviewsState, setAdminReviewsState] = useState({
        currentPage: 1,
        searchList: ''
    });
    const { currentPage, searchList } = adminReviewsState;

    const setStateVariable = (variables) => {
        setAdminReviewsState(prevObject => ({ ...prevObject, ...variables }));

    }
    return (loading || !getWhyHostAllReviews) ? <Loader type={"text"} /> : <AdminReviewsManagement
        currentPage={currentPage}
        searchList={searchList}
        reviewsManagement={reviewsManagement}
        setStateVariable={setStateVariable}
    />;
}

export default compose(
    withStyles(s),
    withQuery(reviewsManagement, {
        name: 'reviewsManagement',
        options: (props) => ({
            variables: {
                currentPage: props.currentPage,
                searchList: props.searchList,
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }))(AdminReviews);